<template>
  <div v-loading="loading">
    <appeal-base-form ref="appeal-base-form" :base-params="form" :edit="false"></appeal-base-form>

    <status-bar :status="form.reviewStatus" class="status-bar"></status-bar>

    <notice-base-form
      v-if="form.bussType === LEVEL_ONE_APPEAL.CP_NOTICE.code"
      style="margin-bottom: 16px;"
      ref="notice-base-form"
      :base-params="form.complaintClaim"
      :edit="false"
    ></notice-base-form>

    <section>
      <el-radio-group v-model="activeTab" size="medium" class="m-b-sm">
        <el-radio-button
          v-for="config in showTabConfig"
          :key="config.value"
          :label="config.value"
          :disabled="config.disabled"
        >
          {{ config.label }}
        </el-radio-button>
      </el-radio-group>
    </section>

    <el-card :header="currentTabConfig.label">
      <keep-alive>
        <template v-if="activeTab === 'trackList'">
          <tort-complaint-add-table
            v-if="form.bussType === LEVEL_ONE_APPEAL.TORT.code"
            :data="form.complaintTrackList"
            disabled
          >
          </tort-complaint-add-table>
          <offline-add-table
            v-else-if="form.bussType === LEVEL_ONE_APPEAL.OFFLINE.code"
            :data="form.complaintTrackList"
            disabled
          >
          </offline-add-table>
          <notice-add-table
            v-else-if="form.bussType === LEVEL_ONE_APPEAL.CP_NOTICE.code"
            :data="form.complaintTrackList"
            disabled
          ></notice-add-table>
        </template>
        <template v-else-if="activeTab === 'confirmList'">
          <confirm-mod></confirm-mod>
        </template>
        <template v-else-if="activeTab === 'history'">
          <el-collapse v-model="activeNames" class="history-mod">
            <el-collapse-item v-for="config in historyTabConfigList" :key="config.value" :title="config.label" :name="config.value">
              <history-table :type="config.value" :complaint-id="complaintId"></history-table>
            </el-collapse-item>
          </el-collapse>
        </template>
        <!-- 匹配歌曲信息 -->
        <template v-else-if="activeTab === 'match'">
          <match-mod :complaint-id="complaintId"></match-mod>
        </template>
      </keep-alive>
    </el-card>
  </div>
</template>

<script>
import { Complaint } from '@/models/Complaint'
import complaintService from '@/api/complaint'
import AppealBaseForm from '../components/AppealBaseForm.vue'
import StatusBar from '../components/StatusBar.vue'
import TortComplaintAddTable from '../components/AddTable/TortComplaintAddTable'
import OfflineAddTable from '../components/AddTable/OfflineAddTable'
import NoticeAddTable from '../components/AddTable/NoticeAddTable'
import NoticeBaseForm from '../components/NoticeBaseForm.vue'

import ConfirmMod from './components/ConfirmMod'
import HistoryTable from './components/HistoryTable.vue'
import MatchMod from './components/MatchMod'

import { LEVEL_ONE_APPEAL, detailTabConfigList, historyTabConfigList } from './const'

export default {
  name: 'AppealDetail',
  components: {
    AppealBaseForm,
    StatusBar,
    TortComplaintAddTable,
    OfflineAddTable,
    HistoryTable,
    ConfirmMod,
    MatchMod,
    NoticeAddTable,
    NoticeBaseForm,
  },
  data() {
    return {
      LEVEL_ONE_APPEAL,
      detailTabConfigList,
      historyTabConfigList,

      activeTab: detailTabConfigList[0].value,
      activeNames: historyTabConfigList.map(config => config.value),
      loading: false,
      form: new Complaint(),
      complaintId: null,
    }
  },
  computed: {
    showTabConfig() {
      return this.detailTabConfigList.filter(config => !config.ifShow || config.ifShow(this.$store.getters))
    },
    currentTabConfig() {
      return this.detailTabConfigList.find(config => config.value === this.activeTab)
    },
  },
  created() {
    const { id, tab } = this.$route.query
    if (id) {
      this.complaintId = +id
      this.fetchData()
    }

    if (tab && this.showTabConfig.find(config => config.value === tab)) {
      this.activeTab = tab
    }
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const data = await complaintService.findById(this.complaintId)
        this.form = new Complaint(data)
      } catch (error) {
        this.$alert(`查询失败.${error.message}`, '错误', {
          type: 'error'
        })
      }
      this.loading = false
    },
  }
}
</script>

<style lang="scss" scoped>
.status-bar {
  margin: 16px 0;
}

.history-mod {
  border: none;

  ::v-deep {
    .el-collapse-item:not(:last-child) {
      margin-bottom: 12px;
    }

    .el-collapse-item__header {
      padding: 0 20px;
      background: #F7F8FA;
      border: none;
    }

    .el-collapse-item__wrap {
      border: none;
    }
  }
}
</style>
